import type { IconDefinition } from '@fortawesome/fontawesome-svg-core'
import { faGoogle, faMicrosoft } from '@fortawesome/free-brands-svg-icons'
import type { CalendarProvider } from './types'

export const providers: Record<
  CalendarProvider,
  {
    type: CalendarProvider
    name: string
    meetingService: string
    icon: IconDefinition
  }
> = {
  google: {
    type: 'google',
    name: 'Google Calendar',
    meetingService: 'Meet',
    icon: faGoogle
  },
  office365: {
    type: 'office365',
    name: 'Microsoft Outlook',
    meetingService: 'Teams',
    icon: faMicrosoft
  }
}
